import React, { useState } from 'react';
import axios from 'axios';
import { SpinnerCircular } from 'spinners-react';


function App() {
  const [file, setFile] = useState(null);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragOver(false);
    setFile(event.dataTransfer.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      alert('Please select an image file to upload.');
      return;
    }

    try {
      const fileReader = new FileReader();
      fileReader.onload = async () => {
        setIsLoading(true); // Set isLoading to true before sending the request

        const imageUrl = fileReader.result;
        //const res = await axios.post('http://localhost:8080/analyze', { imageUrls: [imageUrl] }, {
          const res = await axios.post('https://vc-hack-pitchdeck.fly.dev/analyze', { imageUrls: [imageUrl] }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (res.data.error) {
          console.error(res.data.error);
          setError(res.data.error);
          setResponse(null);
          setIsLoading(false); // Set isLoading to false after handling the error
        } else {
          setResponse(res.data);
          setError(null);
          setIsLoading(false); // Set isLoading to false after handling the success case
        }
      };
      fileReader.readAsDataURL(file);
    } catch (err) {
      console.error(err);
      setError('An error occurred while analyzing the image.');
      setResponse(null);
      setIsLoading(false); // Set isLoading to false after handling the exception
    }
  };

  return (
    <div className="min-h-screen bg-blue-100 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-4">ChatGPT Vision Analysis</h1>
        <form onSubmit={handleSubmit} className="mb-4">
          <div
            className={`border-2 border-dashed rounded-md py-8 px-4 flex items-center justify-center ${
              isDragOver ? 'border-blue-500' : 'border-gray-300'
            }`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <input
              type="file"
              onChange={handleFileChange}
              className="hidden"
              id="fileInput"
            />
            <label
              htmlFor="fileInput"
              className="cursor-pointer text-gray-500 hover:text-blue-500"
            >
              {file ? file.name : 'Drag and drop or click to upload an image'}
            </label>
          </div>
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Analyze
          </button>
        </form>
        {isLoading && (
          <div className="flex justify-center mb-4">
            <SpinnerCircular color="#3b82f6" size={50} />
          </div>
        )}
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {response && (
          <div>
            <h2 className="text-xl font-bold mb-2">Analysis Result</h2>
            <p className="mb-2">{response.text}</p>
            <p className="mb-2">Index: {response.index}</p>
            <p className="mb-2">Finish Reason: {response.finish_reason}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;